module.exports = __webpack_public_path__ + "img/banner2-min-en.b5d39499.jpg";